import {TrimixFeaturedMedData} from "@/design-system/Organisms/TrimixFeaturedMedSection/featuredMed.data"; 

export const trimixFeaturedMedicineConfig = {   
    heading: "Defy Benefits",
    highlightedHeadingMain: "Featured",
    highlightedHeadingAccent: "Trimix Medications",
    describe:"The Trimix medications you want, when you want them.",
    medList: TrimixFeaturedMedData,
};